import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/services/auth.service';

// Attaches the bearer token to outgoing requests and reacts to auth failures.
// SECURITY: BE MUST validate this token on every protected API and answer 401
// (invalid/expired) or 403 (forbidden). The FE simply forwards the token and
// clears local state on those responses.
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();

    const authReq = token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Token rejected by BE -> drop local auth state and return to landing.
          this.authService.clear();
          localStorage.removeItem('AgentUser');
          this.router.navigate(['/']);
        }
        return throwError(() => error);
      })
    );
  }
}
